import React from "react";
import Button from "@material-ui/core/Button";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { i18n } from "../../translate/i18n";
import { useGuide } from "../../context/Guide/GuideContext";

const GuideOpenButton = ({ id, title, to, startId }) => {
  const { openGuide } = useGuide();
  return (
    <Button
      size="small"
      variant="outlined"
      color="primary"
      startIcon={<HelpOutlineIcon />}
      style={{ textTransform: "none", fontWeight: 700, borderRadius: 999 }}
      onClick={() => openGuide({ id, title, to, startId })}
    >
      {i18n.t("gettingStarted.guide")}
    </Button>
  );
};

export default GuideOpenButton;
